export default __webpack_public_path__ + "static/media/display_minimalist.7250c365.png";